// extracted by mini-css-extract-plugin
export default {"headerGray":"headerGray_headerGray__OLlCO"};